import React from 'react'
import { useSelector } from 'react-redux'

import Zoom from '@material-ui/core/Zoom'

const useNativeLoaderHandler = () => {
	const { showPageLoader } = useSelector((state) => state.loading)
	return showPageLoader ? (
		<Zoom in={true}>
			<div className="loading">
				<div className="spinner"></div>
			</div>
		</Zoom>
	) : (
		<></>
	)
}

export default useNativeLoaderHandler
